import { API_BASE } from './base'
import type { BacktestDeatil, CreateEditStrategyVersion, StrategyVersion } from '@/types'

//策略版本列表
export async function getStrategyVersions(managerId: number,status?: string[]): 
Promise<{manager_id: number,manager_name: string, versions: StrategyVersion[]}> {
    const res = await fetch(`${API_BASE}/managers/${managerId}/strategy-versions${status ? `?status=${status.join(',')}` : ''}`)
    return res.json()
}

//创建策略版本
export async function createStrategyVersion(data: any) {
    const res = await fetch(`${API_BASE}/managers/${data.manager_id}/strategy-versions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
    return res.json()
}

//获取策略版本
export async function getStrategyVersion(id: number): Promise<StrategyVersion> {
    const res = await fetch(`${API_BASE}/strategy-versions/${id}`)
    return res.json()
}

//更新策略版本
export async function updateStrategyVersion(id: number, data: CreateEditStrategyVersion): Promise<StrategyVersion> {
    const res = await fetch(`${API_BASE}/strategy-versions/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
    const body = await res.json().catch(() => ({}))
    if (!res.ok) {
        throw new Error((body as { detail?: string }).detail ?? '保存策略版本失败')
    }
    return body as StrategyVersion
}

//提交审批策略版本
export async function submitStrategyVersion(versionId: number) {
    const res = await fetch(`${API_BASE}/strategy-versions/${versionId}/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    })
    return res.json()
}

//通过策略版本
export async function approveStrategyVersion(versionId: number){
    const res = await fetch(`${API_BASE}/strategy-versions/${versionId}/approve`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    })
    return res.json()
}

//驳回策略版本
export async function rejectStrategyVersion(versionId: number, reason: string){
    const res = await fetch(`${API_BASE}/strategy-versions/${versionId}/reject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reject_reason:reason }),
    })
    return res.json()
}

//获取策略版本关联回测列表
export async function getStrategyVersionBacktestList(versionId: number): Promise<{items: BacktestDeatil[]}> {
    const res = await fetch(`${API_BASE}/strategy-versions/${versionId}/backtests`)
    return res.json()
}

//主动触发 AI 提取核心策略参数并写回，返回最新策略版本
export async function extractStrategyParams(versionId: number): Promise<StrategyVersion> {
    const res = await fetch(`${API_BASE}/strategy-versions/${versionId}/extract-params`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    })
    if (!res.ok) {
        const body = await res.json().catch(() => ({}))
        throw new Error((body as { detail?: string }).detail ?? `HTTP ${res.status}`)
    }
    return res.json()
}